import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import HistogramStats from './HistogramStats';
import '../styles/HistogramWidget.css'; // We'll create this file later

// Custom Tooltip for the chart
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-histogram-tooltip">
                <p className="range">{label}</p>
                <p className="count">{`${payload[0].value} posts`}</p>
            </div>
        );
    }
    return null;
};

const HistogramWidget = ({ 
    title,
    data, 
    stats,
    xAxisKey, 
    yAxisLabel = 'Number of Posts',
    barColor = '#8884d8', 
    onBarClick = () => {},
    valueFormatter = (value) => value, // Formatter for stats
    selectedBin = null,
    binStartKey = 'binStart',
    showAverage = true,
    showRange = true,
    showSampleSize = true,
    avgLabel = 'Avg',
    rangeLabel = 'Range',
    sampleLabel = 'Sample',
    avgColor = null, // Optional color for average value
    additionalInfo = null, // Optional component/element for extra info (like spread explanation)
    hideSummaryStats = false // Option to hide summary stats when custom stats display is used
}) => {
    if (!data || data.length === 0) {
        return <div className="histogram-widget">No data available for {title}.</div>;
    }

    return (
        <div className="histogram-widget">
            <h2>{title}</h2>
            {!hideSummaryStats && (
                <HistogramStats 
                    stats={stats}
                    valueFormatter={valueFormatter}
                    showAverage={showAverage}
                    showRange={showRange}
                    showSampleSize={showSampleSize}
                    avgLabel={avgLabel}
                    rangeLabel={rangeLabel}
                    sampleLabel={sampleLabel}
                    avgColor={avgColor}
                />
            )}
            {additionalInfo}
            <div className="histogram-chart-container">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                        <XAxis 
                            dataKey={xAxisKey} 
                            angle={-45}
                            textAnchor="end"
                            height={60}
                            interval="preserveStartEnd"
                            tick={{ fontSize: 12 }}
                        />
                        <YAxis 
                            tick={{ fontSize: 12 }}
                            label={{ 
                                value: yAxisLabel, 
                                angle: -90, 
                                position: 'insideLeft',
                                style: { fontSize: 12, textAnchor: 'middle' } // Ensure label is centered
                            }}
                            allowDecimals={false} // Ensure integer ticks on Y-axis
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar 
                            dataKey="count" 
                            onClick={(entry) => onBarClick(entry)} // Pass the whole entry
                            cursor="pointer"
                            radius={[2, 2, 0, 0]} // Slightly rounded top corners
                        >
                            {data.map((entry, index) => (
                                <Bar 
                                    key={`bar-${index}`} 
                                    fill={typeof barColor === 'function' ? barColor(entry) : barColor} 
                                    opacity={selectedBin !== null && entry[binStartKey] !== selectedBin ? 0.5 : 1}
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default HistogramWidget; 